/** @jsxImportSource @emotion/react */
import { Link } from "react-router-dom";
import { useGetProfileScreenStyles } from "./../Privacy/index.styles";
import appLogo from "../../assets/images/svg/appLogo.svg";
import AboutContent from "./AboutContent";
import Footer1 from "../../components/Footer/Footer";
import ScrollToTopButton from "../../components/ScrollToTopButton";

const About = () => {
  const classes = useGetProfileScreenStyles();
  return (
    <div>
      <div css={classes.privacyContainer}>
        <Link to="/home">
          <div css={classes.logo}>
            <img height={38} src={appLogo} alt="money mails logo" />
          </div>
        </Link>
        <AboutContent />
      </div>
      <Footer1 />
      <ScrollToTopButton />
    </div>
  );
};

export default About;
